import { themeVariables } from "Components/theme";
import { PRESENTATION_TEXT_FILTER_DEF_ID } from "../../constants";
const colorMap = {
    stop: "timeline-presentation-label-bg",
    play: "timeline-presentation-label-bg-play",
    pause: "timeline-presentation-label-bg-play"
};
export default (defs, presentationState) => {
    const filter = defs === null || defs === void 0 ? void 0 : defs.querySelector(`#${PRESENTATION_TEXT_FILTER_DEF_ID}`);
    if (!filter || !presentationState)
        return;
    const feFlood = filter.querySelector("feFlood");
    if (!feFlood)
        return;
    feFlood.setAttribute("flood-color", themeVariables[colorMap[presentationState]]);
};
